(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8416],{

/***/ 60:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/carpetlook",
      function () {
        return __webpack_require__(73751);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 73751:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(6212);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(35005);
/* harmony import */ var sweetalert__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46737);
/* harmony import */ var sweetalert__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(sweetalert__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var algoliasearch_lite__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70290);
/* harmony import */ var algoliasearch_lite__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(algoliasearch_lite__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_instantsearch__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26785);
/* harmony import */ var react_instantsearch__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(54942);
/* harmony import */ var react_instantsearch__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(36292);
/* harmony import */ var react_instantsearch__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(28313);
/* harmony import */ var react_instantsearch__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(65346);
/* harmony import */ var react_instantsearch__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(80377);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var html2canvas__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61120);
/* harmony import */ var html2canvas__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(html2canvas__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var jspdf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91819);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_6__);










//ALGOLIA SEARCH CLIENT DETAILS
const searchClient = algoliasearch_lite__WEBPACK_IMPORTED_MODULE_7___default()("XLDKWU66O5", "NDcxNDEwZmM0OWM3YjQ0NTM5Mjc3Njk2YjRkNGJhOWRiNTNjN2E0MGQ2NzJjZTJkN2NhYTZiODE5ZDM3MzMzMXRhZ0ZpbHRlcnM9");
function TileReplacementModal(param) {
    let { isOpen , onClose , onReplace , setImgUrl , setTileReplacement , tilesUsed , setTilesUsed , newImg , setNewImg  } = param;
    const handleTileSwap = async (url, name)=>{
        setImgUrl(url);
        let arr = [
            ...newImg
        ];
        arr.push(url);
        setNewImg(arr);
        setTilesUsed([
            ...tilesUsed,
            name
        ]);
        onReplace();
        setTileReplacement(false);
        onClose();
    };
    function Hit(param) {
        let { hit  } = param;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "search-result-product",
            onClick: ()=>handleTileSwap(hit.thumbnail_url, hit.name),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: hit.thumbnail_url
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_instantsearch__WEBPACK_IMPORTED_MODULE_8__/* .Highlight */ .y, {
                        attribute: "name",
                        hit: hit
                    })
                })
            ]
        });
    }
    const queryHook = (query, search)=>{
        search(query);
    };
    function NoResultsBoundary(param) {
        let { children , fallback  } = param;
        const { results  } = (0,react_instantsearch__WEBPACK_IMPORTED_MODULE_9__/* .useInstantSearch */ .b)();
        // The `__isArtificial` flag makes sure not to display the No Results message
        // when no hits have been returned.
        if (!results.__isArtificial && results.nbHits === 0) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    fallback,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        hidden: true,
                        children: children
                    })
                ]
            });
        }
        return children;
    }
    function NoResults() {
        const { indexUiState  } = (0,react_instantsearch__WEBPACK_IMPORTED_MODULE_9__/* .useInstantSearch */ .b)();
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                children: [
                    "No results for ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("q", {
                        children: indexUiState.query
                    }),
                    "."
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
        className: "carpetlook-product-popup",
        show: isOpen,
        onHide: onClose,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Header */ .Z.Header, {
                closeButton: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Title */ .Z.Title, {
                    children: "Search Product"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Body */ .Z.Body, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_instantsearch__WEBPACK_IMPORTED_MODULE_11__/* .InstantSearch */ .p, {
                    searchClient: searchClient,
                    indexName: "oblnewver_english1_products",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_instantsearch__WEBPACK_IMPORTED_MODULE_12__/* .SearchBox */ .R, {
                            queryHook: queryHook
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NoResultsBoundary, {
                            fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NoResults, {})
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_instantsearch__WEBPACK_IMPORTED_MODULE_13__/* .Stats */ .j, {
                            translations: {
                                rootElementText (param) {
                                    let { nbHits , processingTimeMS , nbSortedHits , areHitsSorted  } = param;
                                    return nbHits != 0 && "".concat(nbHits.toLocaleString(), " Results Found");
                                }
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_instantsearch__WEBPACK_IMPORTED_MODULE_14__/* .InfiniteHits */ .r, {
                            hitComponent: Hit,
                            showPrevious: false
                        })
                    ]
                })
            })
        ]
    });
}
function Carpetlook() {
    const [groutApplied, setGroutApplied] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    const [rows, setRows] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(6);
    const [cols, setCols] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(6);
    const [rowsInGrid, setRowsInGrid] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(6);
    const [colsInGrid, setColsInGrid] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(6);
    const [rotations, setRotations] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [tileReplacement, setTileReplacement] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [totalTiles, setTolalTiles] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const [rowvalErr, setRowValErr] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [colvalErr, setColValErr] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [selectedTilesForReplacement, setSelectedTilesForReplacement] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [isModalOpen, setIsModalOpen] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [imgUrl, setImgUrl] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [previewModalOpen, setPreviewModalOpen] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [tilesUsed, setTilesUsed] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [replacedTiles, setReplacedTiles] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const [pdtImg, setPdtImg] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(router.query.img);
    const [pdtSku, setPdtSku] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [printPreviewOpen, setPrintPreviewOpen] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const printContentRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const [newImg, setNewImg] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        let totalTilesInGrid = rowsInGrid * colsInGrid;
        setTolalTiles(totalTilesInGrid);
    }, [
        rowsInGrid,
        colsInGrid
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const imgParam = router.query.img;
        setPdtImg(imgParam);
        console.log("00000", router.asPath);
    }, [
        router.query.img
    ]);
    const rotateImage = (index)=>{
        setRotations((prevRotations)=>{
            const newRotations = [
                ...prevRotations
            ];
            newRotations[index] = (newRotations[index] || 0) + 90;
            return newRotations;
        });
    };
    const handleTileReplacement = (index)=>{
        setSelectedTilesForReplacement((prevSelectedTiles)=>{
            // If the tile is already selected, remove it from the list
            if (prevSelectedTiles.includes(index)) {
                const updatedReplacedTiles = {
                    ...replacedTiles
                };
                updatedReplacedTiles[index] = newImg[newImg.length - 1]; // Using the last selected image for replacement
                setReplacedTiles(updatedReplacedTiles);
                return prevSelectedTiles.filter((selectedTile)=>selectedTile !== index);
            } else {
                // If it's not selected, add it to the list
                return [
                    ...prevSelectedTiles,
                    index
                ];
            }
        });
    };
    const openModal = ()=>{
        setIsModalOpen(true);
    };
    const closeModal = ()=>{
        setIsModalOpen(false);
    };
    const onPreviewClose = ()=>{
        setPreviewModalOpen(false);
    };
    const closePrintPreview = ()=>{
        setPrintPreviewOpen(false);
    };
    const replaceTile = ()=>{
        selectedTilesForReplacement && selectedTilesForReplacement.map((tile)=>{});
    };
    const handleReplaceButtonClick = async ()=>{
        if (selectedTilesForReplacement.length == 0) {
            sweetalert__WEBPACK_IMPORTED_MODULE_2___default()("Please select at least one tile image to swap");
        } else {
            openModal();
        }
    };
    function download(dataUrl, filename) {
        const a = document.createElement("a");
        a.href = dataUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }
    //Fun to download the grid as an img
    const handleDownload = async ()=>{
        setPreviewModalOpen(true);
        //  to ensure that the modal content is rendered before downloading
        setTimeout(()=>{
            // Get the modal node by its ID
            const modalNode = document.getElementById("preview-modal");
            // html2canvas is to capture the content of the modal as an image
            html2canvas__WEBPACK_IMPORTED_MODULE_4___default()(modalNode).then((canvas)=>{
                // Convert the canvas to a data URL
                const dataUrl = canvas.toDataURL("image/png");
                // Trigger a download for the data URL
                download(dataUrl, "grid_preview.png");
                // Close the modal
                setPreviewModalOpen(false);
            });
        }, 2000);
    };
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (rows > 6) {
            setRowValErr("Rows cannot be more than 6");
            setTimeout(()=>setRowValErr(""), 4000);
        }
        if (rows < 1) {
            setRowValErr("At least one row is needed");
            setTimeout(()=>setRowValErr(""), 4000);
        }
        if (cols > 6) {
            setColValErr("Columns cannot be more than 6");
            setTimeout(()=>setColValErr(""), 4000);
        }
        if (cols < 1) {
            setColValErr("At least one column is needed");
            setTimeout(()=>setColValErr(""), 4000);
        }
        if (!rowvalErr && !colvalErr) {
            setRowsInGrid(rows);
            setColsInGrid(cols);
            setRotations([]);
        }
    };
    const renderTileGrid = ()=>{
        return Array.from({
            length: rowsInGrid
        }, (_, rowIndex)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "row",
                children: Array.from({
                    length: colsInGrid
                }, (_, colIndex)=>{
                    const tileIndex = rowIndex * colsInGrid + colIndex;
                    // Check if the current tile is selected for replacement
                    const isSelectedForReplacement = selectedTilesForReplacement.includes(tileIndex);
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "".concat(rowIndex).concat(colIndex),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: router.asPath == "/carpetlook" ? "carpet-look-default.avif" : isSelectedForReplacement && newImg.length > 0 ? newImg[newImg.length - 1] // Use the last selected image for replacement
                                     : replacedTiles[tileIndex] || pdtImg // Use the replaced image if available, otherwise the defaut
                                    ,
                                    alt: "New tile image",
                                    className: groutApplied === true ? "withGroutBorder" : "",
                                    style: {
                                        transform: "rotate(".concat(rotations[tileIndex] || 0, "deg)")
                                    },
                                    onClick: ()=>rotateImage(tileIndex)
                                }),
                                tileReplacement && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                    type: "checkbox",
                                    onChange: ()=>handleTileReplacement(tileIndex),
                                    checked: isSelectedForReplacement
                                })
                            ]
                        })
                    }, colIndex);
                })
            }, rowIndex));
    };
    const handlePrintButtonClick = ()=>{
        console.log(document.getElementsByClassName("img-section")[0].innerHTML);
        // return
        // setPreviewModalOpen(true)
        const printWindow = window.open("", "_blank");
        printWindow.document.title = "Print Message";
        const templateContent = document.createElement("div");
        templateContent.innerHTML = document.getElementsByClassName("img-section")[0].innerHTML;
        printWindow.document.body.appendChild(templateContent);
        printWindow.print();
        printWindow.close();
        // Used setTimeout to ensure that the modal content is rendered before printing
        setTimeout(()=>{
        // window.print(); 
        // setPrintPreviewOpen(false);
        // printModalContent();
        }, 1500);
    };
    const printModalContent = ()=>{
        const content = document.getElementById("preview-modal");
        if (content) {
            const pdf = new jspdf__WEBPACK_IMPORTED_MODULE_5__/* .jsPDF */ .kH();
            pdf.html(content, {
                callback: ()=>{
                    pdf.save("carpetlook.pdf");
                    setPreviewModalOpen(false);
                }
            });
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_6___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Try Different Laying patterns | Orientbell"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "title",
                        content: "Try Different Laying patterns | Orientbell"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "Orientbell Carpet look helps visualize the tiles in different laying patterns and combinations."
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "carpet_looks",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "carpet-left-sec",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                    children: "Trying different laying patterns"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: "Carpet look helps visualize the tiles in different laying patterns and combinations."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "tile-used-section",
                                    children: [
                                        tilesUsed.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                            children: "Tiles Used"
                                        }),
                                        tilesUsed.length > 0 && tilesUsed.map((item, index)=>{
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                                className: "tiles_added",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    children: item
                                                })
                                            }, index);
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "dynamic-section",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "carpet-logo",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: "CarpetlookLogo.jpg",
                                        alt: "Carpet Look Logo"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                                    className: "tilecalculation",
                                    id: "tilecalculation",
                                    onSubmit: handleSubmit,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "grout",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                    type: "checkbox",
                                                    checked: !groutApplied,
                                                    onChange: ()=>setGroutApplied(!groutApplied)
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                    children: "Select to remove the grout between the tiles"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "img-section",
                                            children: rowsInGrid > 0 && rowsInGrid < 7 && colsInGrid > 0 && colsInGrid < 7 && renderTileGrid()
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "replace-tile",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                    type: "checkbox",
                                                    checked: tileReplacement,
                                                    onChange: ()=>setTileReplacement(!tileReplacement)
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                    children: "Select the tile to be replaced with other tile"
                                                }),
                                                tileReplacement && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                    onClick: handleReplaceButtonClick,
                                                    children: "Click to Replace Tile"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TileReplacementModal, {
                                                    isOpen: isModalOpen,
                                                    onClose: closeModal,
                                                    onReplace: replaceTile,
                                                    setImgUrl: setImgUrl,
                                                    setTileReplacement: setTileReplacement,
                                                    tilesUsed: tilesUsed,
                                                    setTilesUsed: setTilesUsed,
                                                    newImg: newImg,
                                                    setNewImg: setNewImg
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "measurement",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                            children: "Number of rows*"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                            type: "number",
                                                            name: "rows",
                                                            value: rows,
                                                            onChange: (e)=>{
                                                                setRows(e.target.value);
                                                            },
                                                            required: true
                                                        }),
                                                        rowvalErr && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "error text-danger",
                                                            children: rowvalErr
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                            children: "Number of columns*"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                            type: "number",
                                                            name: "cols",
                                                            value: cols,
                                                            onChange: (e)=>{
                                                                setCols(e.target.value);
                                                            },
                                                            required: true
                                                        }),
                                                        colvalErr && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "error text-danger",
                                                            children: colvalErr
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "measurement-button",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                type: "submit",
                                                onClick: handleSubmit,
                                                children: "Submit"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "note",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                                        children: "Note: Use of Spacer is strongly recommended for laying tiles"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "carpet-sec-right",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "carpet-sec-button-bx",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                onClick: ()=>setPreviewModalOpen(true),
                                                children: "Preview"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                href: "https://wa.me/918750733333?text=Hi, I am interested in Orientbell Tiles. I am currently browsing https://www.orientbell.com/",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                            src: "whatsapp.svg",
                                                            alt: "Icon"
                                                        }),
                                                        " "
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                onClick: handleDownload,
                                                children: "Download"
                                            })
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            className: "carpetlook-product-popup",
                            id: "preview-modal",
                            show: previewModalOpen,
                            onHide: onPreviewClose,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Header */ .Z.Header, {
                                    closeButton: true
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Body */ .Z.Body, {
                                    children: renderTileGrid()
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["default"] = (Carpetlook);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7847,5443,4585,6212,6737,6027,9774,2888,179], function() { return __webpack_exec__(60); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);